<template>
  <div
    class="carousel-fourth"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/images/index/carousel-4.jpg') + ')',
    }"
  >
    <div class="carousel-content">
      <div class="carousel-header">
        <div class="header-title">{{ $t("index.activity") }}</div>
        <div class="header-tips">{{ $t("index.activityTips") }}</div>
      </div>

      <div class="carousel-slider" ref="carouselSlider">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="slider-item transition"
          :ref="'slider' + index"
          :style="{
            marginLeft:
              index === 0
                ? -indicatorsIndex * 656 - 96 * indicatorsIndex + 'px'
                : '',
          }"
          @click="toDetail(item)"
        >
          <div class="silder-time">
            <div class="silder-day">
              {{ dateFormat(new Date(item.publishTime), "dd") }}
            </div>
            <div class="silder-year_mother">
              {{ dateFormat(new Date(item.publishTime), "yyyy.MM") }}
            </div>
          </div>
          <img class="slider-img" :src="item.thumb" />
          <div class="slider-title">{{ item.title }}</div>
          <div class="slider-desc">{{ item.brief }}</div>
          <div class="slider-footer">
            <div class="slider-category">{{ $t("index.activity") }}</div>
            <img
              class="slider-arrow"
              src="@/assets/images/index/arrow-green.png"
            />
          </div>
        </div>
        <div class="slider-more transition" @click="handleMore">
          <div class="more-title">{{ $t("index.activityAll") }}</div>
          <div>More</div>
        </div>
      </div>
      <div class="slider-indicators">
        <div class="indicators-content">
          <div
            v-for="(item, index) in Math.ceil(list.length / 2)"
            :key="index"
            class="indicators-item"
            @click="handleIndicatorsIndex(index)"
          >
            {{ index + 1 < 10 ? "0" + (index + 1) : index + 1 }}
          </div>
        </div>
        <div
          class="indicators-active"
          :style="{
            width: 100 / Math.ceil(list.length / 2) + '%',
            marginLeft:
              (indicatorsIndex * 100) / Math.ceil(list.length / 2) + '%',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsPage } from "@/api/common";
import { dateFormat } from "@/utils/date.js";
export default {
  data() {
    return {
      dateFormat: dateFormat,
      list: [],
      indicatorsIndex: 0,
    };
  },

  created() {
    getNewsPage({
      categoryId: "1838760057651851266",
      descs: "publish_time",
    }).then((res) => {
      this.list = res.data.records;
    });
  },
  methods: {
    toDetail(row) {
      this.$router.push("/activity/detail?id=" + row.id);
    },
    handleIndicatorsIndex(index) {
      this.indicatorsIndex = index;
    },
    handleMore() {
      this.$router.push("/activity/list");
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-fourth {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100%;
  .carousel-content {
    padding-top: 88px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .carousel-header {
    text-align: center;
    .header-title {
      margin-top: 90px;
      color: #fff;
      font-size: 48px;
      font-weight: 700;
      line-height: 26px;
      letter-spacing: 4.32px;
    }
    .header-tips {
      margin-top: 36px;
      color: #fff;
      font-size: 18px;
      font-weight: 400;
      line-height: 26px;
      letter-spacing: 1.62px;
    }
  }
  .carousel-slider {
    margin-top: 60px;
    width: 1330px;
    display: flex;
    padding-top: 60px;
    overflow: hidden;
    // overflow-x: auto;
    .slider-item {
      width: 328px;
      box-sizing: border-box;
      background: #fff;
      padding: 16px;
      cursor: pointer;

      position: relative;
      .silder-time {
        position: absolute;
        width: 78px;
        height: 78px;
        background-color: #009d94;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        top: 0;
        transform: translate(0, -50%);
        .silder-day {
          color: #fff;
          font-size: 28px;
          font-weight: 700;
          line-height: 24px; /* 85.714% */
        }
        .silder-year_mother {
          margin-top: 10px;
          color: #fff;
          font-size: 14px;
          font-weight: 400;
          line-height: 24px; /* 171.429% */
        }
      }
      .slider-img {
        object-fit: cover;
        width: 296px;
        height: 200px;
      }
      .slider-title {
        margin-top: 21px;
        color: #222;
        font-size: 20px;
        font-weight: 400;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .slider-desc {
        color: #666;
        font-size: 14px;
        font-weight: 400;
        line-height: 26px; /* 185.714% */
        height: 52px;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 显示的行数，可以根据需要修改 */
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .slider-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .slider-category {
          color: #666;
          font-size: 14px;
          font-weight: 400;
          line-height: 26px; /* 185.714% */
        }
        .slider-arrow {
          width: 20px;
          display: block;
        }
      }
      + .slider-item {
        margin-left: 48px;
      }
      &:hover {
        box-shadow: inset 0 0 0 4px #009d94;
      }
    }
    .slider-more {
      width: 328px;
      flex-shrink: 0;
      box-sizing: border-box;
      background: #c4c4c4;
      border: 16px solid #ffffff;
      margin-left: 48px;
      cursor: pointer;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #ffffff;

      color: #fff;
      font-size: 28px;
      font-weight: 700;
      line-height: 24px; /* 85.714% */
      .more-title {
        margin-bottom: 22px;
      }
      &:hover {
        background-color: #009d94;
      }
    }
  }
  .slider-indicators {
    margin-top: 50px;
    width: 600px;
    padding: 0 20px;
    border-bottom: 1px solid #fff;
    .indicators-content {
      display: flex;
      width: 100%;
      .indicators-item {
        flex: 1;
        height: 40px;
        line-height: 40px;
        color: #fff;
        text-align: center;
        font-size: 15px;
        font-weight: 400;
        cursor: pointer;
      }
    }
    .indicators-active {
      height: 2px;
      background: #fff;
    }
  }
}
</style>
